import React, { useState } from 'react';
import StageCard from './StageCard';
import { EmptyCollection } from '../../../../shared_elements';

const StagesTab = ({ templateId, stages, loading, onEditStage, onDeleteStage, onReorderStages }) => {
  const [dragIndex, setDragIndex] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);

  if (!templateId) {
    return <EmptyCollection title="Select a template to view its stages" />;
  }

  const stageList = stages || [];

  if (!loading && !stageList.length) {
    return <EmptyCollection title="No stages configured for this template yet" />;
  }

  const resetDrag = () => {
    setDragIndex(null);
    setDragOverIndex(null);
  };

  const handleDrop = (dropIndex) => {
    if (dragIndex === null || dragIndex === dropIndex) { resetDrag(); return; }
    const reordered = [...stageList];
    const [moved] = reordered.splice(dragIndex, 1);
    reordered.splice(dropIndex, 0, moved);
    resetDrag();
    onReorderStages && onReorderStages(reordered);
  };

  return (
    <div style={{ maxWidth: '100%', display: 'flex', flexDirection: 'column' }}>
      {stageList.map((stage, index) => (
        <StageCard
          key={stage?.id}
          stage={stage}
          onEdit={onEditStage}
          onDelete={onDeleteStage}
          isLast={index === stageList.length - 1}
          draggable={!!onReorderStages}
          isDragging={dragIndex === index}
          isDragOver={dragOverIndex === index && dragIndex !== index}
          onDragStart={() => setDragIndex(index)}
          onDragEnter={() => setDragOverIndex(index)}
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => { e.preventDefault(); handleDrop(index); }}
          onDragEnd={resetDrag}
        />
      ))}
    </div>
  );
};

export default StagesTab;
